import React from 'react'
import GoogleLogo from 'images/GoogleLogo'
import GitLabLogo from 'images/GitLabLogo'
import styled from '@emotion/styled'
import withProps from 'recompose/withProps'
import urlForProvider from '../utils/urlForProvider'
import { Button, color } from 'stylist'

const GoogleButton = styled(Button)`
  border: 0 none;
  padding: 0;
  background: ${color('white')};
`

export default withProps(({ label, onError, valid }) => ({
  children:
    process.env.NODE_ENV === 'development' ? (
      <GitLabLogo width="1.75rem" />
    ) : (
      <GoogleLogo alt="Google" />
    ),

  onClick: e => {
    e.preventDefault()
    if (valid) {
      window.location.replace(urlForProvider('google'))
    } else {
      onError()
    }
  }
}))(GoogleButton)



// WEBPACK FOOTER //
// ./src/components/GoogleButton.js